var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcnVideos = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-videos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2.92969H8C6.9 2.92969 6 3.82493 6 4.91912V16.8557C6 17.9499 6.9 18.8452 8 18.8452H20C21.1 18.8452 22 17.9499 22 16.8557V4.91912C22 3.82493 21.1 2.92969 20 2.92969ZM4 6.90856H2V20.8346C2 21.9288 2.9 22.8241 4 22.8241H18V20.8346H4V6.90856ZM18 10.8874L12 6.4112V15.3637L18 10.8874Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcnVideos);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icn-videos.3b464e42733d07c04229efb6a93541cd.svg";